<template>
  <div class="outdated">
    <div class="subpage-header">
      <h2 class="normal" id="page-title-for-sr">
        <span class="sr-only">{{ $t('confirmation.pageTitle') }}: </span>
        <span aria-live="assertive" role="status" v-html="$t('confirmation.outdated.header')"></span>
      </h2>
    </div>
    <p v-html="$t('confirmation.outdated.description')"></p><p v-html="$t('confirmation.outdated.description2')"></p>
  </div>
</template>
<script>
export default {
  name: 'ConfirmationOutdated'
}
</script>
